import React, { useState } from 'react';
import styles from './styles/PreviewImage.modal.module.scss';
import { Ssvg } from './Ssvg';
import { createPortal } from 'react-dom';
import { FlatPreview } from '../../Pages/product-arch-blank/components/Images/FlatPreview';
import { SuspenseImage } from './SuspenseImage';
export const PreviewImageModal = ({ activeIndex, listOfImages }) => {
    const [imgIndex, setImgIndex] = useState(activeIndex);
    const image = listOfImages[imgIndex];
    return createPortal(React.createElement(React.Fragment, null,
        React.createElement("div", { className: `pos:f z:900 t:50p l:50p trf:t:-50p bxsh:1 bg:white ${styles.container}` },
            React.createElement("button", { className: "btn:cleared pos:a z:2 l:0 t:0 b:0 d:flex ai:center jc:start w:1/3", onClick: () => {
                    const prevIndex = imgIndex - 1;
                    setImgIndex(prevIndex < 0 ? listOfImages.length - 1 : prevIndex);
                } },
                React.createElement("span", { className: "d:flex ai:center jc:center trs h:56 w:56 bg:white op:0.6 hover:op:1" },
                    React.createElement(Ssvg, { icon: "#icon--arrow-slider-left", className: "h:24" }))),
            typeof image === 'string'
                ? React.createElement(SuspenseImage, { src: image, height: 1200, width: 1200, alt: "", className: `pos:r z:1 image:cover bg:f4f4f4 ${styles.image}`, loaderClassName: `d:block pos:r h:100p w:100p ar:1 ${styles.image}` })
                : React.createElement("span", { className: `d:block ar:1 w:100p h:100p ${styles.image}` },
                    React.createElement(FlatPreview, { data: image })),
            React.createElement("button", { className: "btn:cleared pos:a z:2 r:0 t:0 b:0 d:flex ai:center jc:end w:1/3", onClick: () => {
                    const nextIndex = imgIndex + 1;
                    setImgIndex(nextIndex === listOfImages.length ? 0 : nextIndex);
                } },
                React.createElement("span", { className: "d:flex ai:center jc:center trs h:56 w:56 bg:white op:0.6 hover:op:1" },
                    React.createElement(Ssvg, { icon: "#icon--arrow-slider-right", className: "h:24" })))),
        React.createElement(Ssvg, { icon: "#icon--close-x", aspectRatio: "1 / 1", className: "pos:f z:900 t:10 r:10 h:20 pev:none color:white" })), document.body);
};
